/**
 * Safely validate and get a timezone
 * Prevents RangeError from invalid timezone strings
 * @param {string} timezoneToValidate - Timezone to validate
 * @returns {string} Valid IANA timezone identifier (or UTC fallback)
 */
export const getSafeTimezone = (timezoneToValidate = null) => {
  try {
    // If no timezone provided, try to detect from browser
    const timezone = timezoneToValidate || Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    // Validate by attempting to create a DateTimeFormat with it
    new Intl.DateTimeFormat('en-US', { timeZone: timezone });
    
    return timezone;
  } catch (error) {
    console.error('[getSafeTimezone] Invalid timezone:', timezoneToValidate, error);
    // Fallback to UTC if validation fails
    return 'UTC';
  }
};
